export default __webpack_public_path__ + "static/biegun-polnocny-2001-cz-ii-62@2x-4831ca39e905d056c1dd71bd2e7dc218.jpg";